import { render, staticRenderFns } from "./siteHeader.vue?vue&type=template&id=0a47e1d1&"
import script from "./siteHeader.vue?vue&type=script&lang=js&"
export * from "./siteHeader.vue?vue&type=script&lang=js&"
import style0 from "./siteHeader.vue?vue&type=style&index=0&id=0a47e1d1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports